// extracted by mini-css-extract-plugin
module.exports = {"merchantCreate":"merchant-create_merchantCreate_2EemS","btnWrap":"merchant-create_btnWrap_3BWoa"};